import { useEffect, useState } from "react";
import { ToastPortal } from "../../src/shared/ui/toast";

/**
 * Client-only wrapper for ToastPortal.
 * Prevents SSR hydration issues by only rendering after mount.
 */
export function ClientOnlyToastPortal() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return null;
  }

  return <ToastPortal />;
}

